<form class="sa-search-and-pick-form" [formGroup]="searchForm">
  <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
    <span
      *ngIf="showSearchAndCancelIcons && isSearchIconDisplay"
      class="hd-icon hd-icon-search search-icon"
      id="searchIcon"
    ></span>
    <input
      #autoCompleteInput
      type="text"
      matInput
      [ngClass]="{ addIndent: showSearchAndCancelIcons, removeIndent: !isSearchIconDisplay }"
      matAutocompleteTrigger
      #trigger="matAutocompleteTrigger"
      (keydown.enter)="$event.target.blur(); trigger.closePanel()"
      class="searchInput"
      [matAutocomplete]="auto"
      [placeholder]="placeholder"
      matTooltip="{{ !!selectedItem ? displayFn(selectedItem, 'title') : '' }}"
      matTooltipPosition="above"
      matTooltipClass="assist-mat-tooltip"
      formControlName="inputControl"
      [(value)]="searchFilter"
      [matTooltipDisabled]="disableTooltip"
    />
    <span
      *ngIf="showSearchAndCancelIcons && searchInputText.value"
      class="hd-icon hd-icon-close close-icon"
      (click)="clearSearch()"
    ></span>
  </mat-form-field>

  <mat-autocomplete
    *ngIf="
      itemTemplateName === 'privacyUserCardTemplate' ||
      itemTemplateName === 'purgeIncidentCardTemplate' ||
      itemTemplateName === 'privacyDeviceCardTemplate'
    "
    panelClass="sa-mat-autocomplete-panel"
    disableRipple
    #auto="matAutocomplete"
    [displayWith]="displayWrapped"
    sa-stop-propagation
    class="privacy-search-panel"
    (optionSelected)="optionSelected($event, $event.option.value.item)"
  >
    <ng-container *ngIf="searchInputText?.value != ''">
      <ng-container *ngIf="itemTemplateName === 'privacyUserCardTemplate'">
        <mat-option
          *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper"
          [value]="wrappedItem"
          class="privacyCardTemplate"
          disableRipple
        >
          <div class="searchResult">
            <div class="userBadge">
              <xs-user-badge
                [size]="'sm'"
                [userName]="wrappedItem.item.fullName || wrappedItem.item.displayName || wrappedItem.item.userName"
              ></xs-user-badge>
            </div>
            <div class="userDetail">
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.displayName"
                [fullText]="'Display Name: ' + wrappedItem.item.displayName"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.firstName"
                [fullText]="'First Name: ' + wrappedItem.item.firstName"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.lastName"
                [fullText]="'Last Name: ' + wrappedItem.item.lastName"
              ></span>
              <span
                class="userInfo lastRow"
                *ngIf="wrappedItem.item.phoneNumber"
                sa-ellipsis
                [fullText]="'Phone Number: ' + wrappedItem.item.phoneNumber"
              ></span>
              <span
                class="userInfo lastRow"
                *ngIf="wrappedItem.item.email"
                sa-ellipsis
                [fullText]="'Email: ' + wrappedItem.item.email"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.userId"
                [fullText]="'User Id: ' + wrappedItem.item.userId"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.userType"
                [fullText]="'User Type: ' + wrappedItem.item.userType"
              ></span>
            </div>
          </div>
        </mat-option>
      </ng-container>
      <ng-container *ngIf="itemTemplateName === 'privacyDeviceCardTemplate'">
        <mat-option
          *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper"
          [value]="wrappedItem"
          class="privacyCardTemplate"
          disableRipple
        >
          <div class="searchResult">
            <div class="userBadge">
              <xs-user-badge [size]="'sm'" [userName]="wrappedItem.item.DeviceName"></xs-user-badge>
            </div>
            <div class="userDetail">
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.DeviceName"
                [fullText]="'Device Name: ' + wrappedItem.item.DeviceName"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.McDeviceId"
                [fullText]="'Device Id: ' + wrappedItem.item.McDeviceId"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.IMEI_MEID_ESN"
                [fullText]="'IMEI: ' + wrappedItem.item.IMEI_MEID_ESN"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.SerialNumber"
                [fullText]="'Serial Number: ' + wrappedItem.item.SerialNumber"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.MACAddress"
                [fullText]="'MAC Address: ' + wrappedItem.item.MACAddress"
              ></span>
            </div>
          </div>
        </mat-option>
      </ng-container>
      <ng-container *ngIf="itemTemplateName === 'purgeIncidentCardTemplate'">
        <mat-option
          class="purgeIncidentCardTemplate"
          disableRipple
          *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper"
          [value]="wrappedItem"
        >
          <div class="incident-row fill">
            <div class="condensed middle card line-md ticketBadge">
              <span class="hd-icon middle hd-icon-issue icon-xlg hd-badge-anchor line-sm show">
                <span class="hd-badge line-sm show" [ngClass]="getGlyphicon(wrappedItem.item)"></span>
              </span>
            </div>
            <div class="middle card left-padding ticketDetail">
              <div class="line-xs ticketInfo firstRow">
                <strong>
                  <div
                    one-time="false"
                    append-to-body="true"
                    sa-ellipsis
                    [fullText]="wrappedItem.item.subject"
                    class="dropdown-title"
                  ></div>
                </strong>
              </div>
              <div class="subtext-gray line-xxs ticketInfo lastRow">
                <span class="xsight-body3" style="color: inherit">{{ wrappedItem.item.prefixedId }}</span>
                <span class="list-separator"></span>
                <div
                  class="ticket-group-name subtext"
                  matTooltipClass="assist-mat-tooltip top"
                  [matTooltip]="wrappedItem.item.groupName"
                  matTooltipPosition="above"
                  matTooltipShowDelay="400"
                  [matTooltipDisabled]="wrappedItem.item.groupName.length < 10"
                >
                  {{ wrappedItem.item.groupName }}
                </div>
                <span class="list-separator"></span>
                <div class="ticket-status">
                  <span class="hd-icon" [ngClass]="getGlyphicon(wrappedItem.item)"></span>
                  <span class="status-caption">{{ wrappedItem.item.status }}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-option>
      </ng-container>
      <mat-option *ngIf="(filteredItems | async)?.length == 0">
        <span class="search-and-pick-no-match">{{ 'searchAndPick_NoMatchesFound_Caption' | xsI18n }}</span>
      </mat-option>
    </ng-container>
  </mat-autocomplete>
  <mat-autocomplete
    *ngIf="itemTemplateName !== 'privacyUserCardTemplate'"
    panelClass="sa-mat-autocomplete-panel"
    disableRipple
    #auto="matAutocomplete"
    [displayWith]="displayWrapped"
    sa-stop-propagation
    (optionSelected)="optionSelected($event, $event.option.value.item)"
  >
    <ng-container *ngIf="searchInputText?.value != ''">
      <ng-container *ngIf="itemTemplateName === 'watcherCardTemplate'">
        <mat-option
          class="watcherCardTemplate"
          disableRipple
          *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper"
          [value]="wrappedItem"
        >
          <div class="searchResult">
            <div class="userBadge">
              <xs-user-badge [size]="'sm'" [userName]="wrappedItem.item.fullName"></xs-user-badge>
            </div>
            <div class="userDetail">
              <span class="userInfo firstRow" sa-ellipsis [fullText]="wrappedItem.item.fullName"></span>
              <span
                class="userInfo lastRow"
                *ngIf="wrappedItem.item.phoneNumber"
                sa-ellipsis
                [fullText]="wrappedItem.item.phoneNumber"
              ></span>
              <span
                class="userInfo lastRow"
                *ngIf="wrappedItem.item.email"
                sa-ellipsis
                [fullText]="wrappedItem.item.email"
              ></span>
            </div>
          </div>
        </mat-option>
      </ng-container>
      <ng-container *ngIf="itemTemplateName === 'assigneeCardTemplate'">
        <mat-option
          class="assigneeCardTemplate"
          disableRipple
          *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper"
          [value]="wrappedItem"
        >
          <div class="searchResult">
            <div class="userBadge">
              <xs-user-badge [size]="'sm'" [userName]="wrappedItem.item.displayName"></xs-user-badge>
            </div>
            <div class="userDetail">
              <span class="userInfo firstRow" sa-ellipsis [fullText]="wrappedItem.item.displayName | xsI18n"></span>
              <span
                class="userInfo lastRow"
                *ngIf="wrappedItem.item.userGroups"
                sa-ellipsis
                [fullText]="wrappedItem.item.userGroups"
              ></span>
              <span
                class="userInfo lastRow"
                *ngIf="wrappedItem.item.email"
                sa-ellipsis
                [fullText]="wrappedItem.item.email"
              ></span>
            </div>
          </div>
        </mat-option>
      </ng-container>
      <ng-container *ngIf="itemTemplateName === 'incidentCardTemplate'">
        <mat-option
          class="incidentCardTemplate"
          disableRipple
          *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper"
          [value]="wrappedItem"
        >
          <div class="incident-row fill">
            <div class="condensed middle card-icon line-md ticketBadge">
              <span class="hd-icon middle hd-icon-issue icon-xlg hd-badge-anchor line-sm show">
                <span class="hd-badge line-sm show" [ngClass]="getGlyphicon(wrappedItem.item)"></span>
              </span>
            </div>
            <div class="middle card-detail left-padding ticketDetail">
              <div class="line-xs ticketInfo firstRow">
                <strong>
                  <div
                    one-time="false"
                    append-to-body="true"
                    sa-ellipsis
                    [fullText]="wrappedItem.item.subject"
                    class="dropdown-title"
                  ></div>
                </strong>
              </div>
              <div class="subtext-gray line-xxs ticketInfo lastRow">
                <span class="xsight-body3" style="color: inherit">{{ wrappedItem.item.prefixedId }}</span>
              </div>
            </div>
          </div>
        </mat-option>
      </ng-container>
      <ng-container *ngIf="itemTemplateName === 'reporterCardTemplate'">
        <mat-option
          *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper"
          [value]="wrappedItem"
          class="reporterCardTemplate"
          disableRipple
        >
          <div class="searchResult">
            <div class="userBadge">
              <xs-user-badge
                [size]="'sm'"
                [userName]="wrappedItem.item.fullName || wrappedItem.item.displayName || wrappedItem.item.userName"
              ></xs-user-badge>
            </div>
            <div class="userDetail">
              <span
                class="userInfo firstRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.userName"
                [fullText]="wrappedItem.item.userName"
              ></span>
              <span
                class="userInfo firstRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.displayName"
                [fullText]="wrappedItem.item.displayName"
              ></span>
              <span
                class="userInfo firstRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.fullName"
                [fullText]="wrappedItem.item.fullName"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.userInfoPublicId"
                [fullText]="wrappedItem.item.userInfoPublicId"
              ></span>
              <span
                class="userInfo lastRow"
                sa-ellipsis
                *ngIf="wrappedItem.item.userType"
                [fullText]="wrappedItem.item.userType"
              ></span>
              <span
                class="userInfo lastRow"
                *ngIf="wrappedItem.item.phoneNumber"
                sa-ellipsis
                [fullText]="wrappedItem.item.phoneNumber"
              ></span>
              <span
                class="userInfo lastRow"
                *ngIf="wrappedItem.item.email"
                sa-ellipsis
                [fullText]="wrappedItem.item.email"
              ></span>
            </div>
          </div>
        </mat-option>
      </ng-container>
      <ng-container *ngIf="itemTemplateName == 'None'">
        <mat-option
          disableRipple
          sa-stop-propagation
          *ngFor="let wrappedItem of filteredItems | async | saMatOptionDisplayWrapper"
          [value]="wrappedItem"
          [matTooltip]="displayFn(wrappedItem.item, 'title')"
          [matTooltipDisabled]="wrappedItem.__sa_option_ui.disableTooltip"
          matTooltipPosition="above"
          matTooltipClass="assist-mat-tooltip"
        >
          <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: wrappedItem.item }">
          </ng-container>
        </mat-option>
      </ng-container>
      <mat-option *ngIf="(filteredItems | async)?.length == 0">
        <span class="search-and-pick-no-match">{{ 'searchAndPick_NoMatchesFound_Caption' | xsI18n }}</span>
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</form>
